import { Fragment } from 'react';
import { Typography, Grid, Box, Stack } from '@mui/material';
import Form from 'components/Form';
import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';
import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const checks = [
  {
    label: '鎖骨下導管 (Subclavian Catheter)',
    key: 'no1.checked1',
  },
  {
    label: '希克曼導管 (Hickman Catheter)',
    key: 'no1.checked2',
  },
  {
    label: '經外周插入的中心靜脈導管 (PICC)',
    key: 'no1.checked3',
  },
  {
    label: '化療端口 (Chemo-port)',
    key: 'no1.checked4',
  },
];

const CVCone = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <Fragment>
      <SectionTitle title="1.  中心靜脈導管的定義與類型" />

      <Box sx={{ margin: '38px 0px 30px 20px' }}>
        <Grid container xs={11.8}>
          <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>
            與位於手或腳等區域的小外周靜脈不同，中心靜脈指與軀幹相連並通向心臟的大靜脈，例如鎖骨下靜脈、頸靜脈和股靜脈。中心靜脈導管是一種插入這些大靜脈的導管。一旦插入並正常工作，它可以連續使用，無需每次治療時單獨進行血管通路操作（如涉及靜脈注射）。
          </Typography>
          {checks.map((v, i) => {
            return (
              <Grid item xs={11.5} sx={{ margin: '0px 0 0 15px' }}>
                <Form.MuiCheckbox
                  label={v.label}
                  disabled={disabled}
                  defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                  onChange={(_, checked) => {
                    setValue(v.key, checked);
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Fragment>
  );
};

export default CVCone;
